import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FullScreenDataContainer
  from 'Components/ComponentLibrary/Components/Uncategorized/DataContainer/FullScreenDataContainer';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import useUserContext from 'Context/UserContext';
import OnboardingHasUser from 'Views/Onboarding/OnboardingHasUser';
import OnboardingTokenExpired from 'Views/Onboarding/Pages/OnboardingTokenExpired';
import useLoginTokenExperimental from 'Views/Onboarding/Hooks/useLoginTokenExperimental';


const styles = () => ({
  root: {},
});

const OnboardingContainer = ({
  classes,
  className,
}) => {
  const { userResource } = useUserContext();
  const { isLoggingIn, error } = useLoginTokenExperimental();

  if (error) {
    return (
      <OnboardingTokenExpired />
    );
  }

  return (
    <FullScreenDataContainer
      className={classNames(classes.root, className)}
      component={OnboardingHasUser}
      loading={!userResource || isLoggingIn}
    />
  );
};

OnboardingContainer.defaultProps = {
  className: '',
};

OnboardingContainer.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OnboardingContainer);
